import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/home',
            name: 'village_home',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
                closeAppModal: true,
                showMembership: true,
                appContainerClass: 'noTransform'
            }
        },
        {
            path: '/village/ristoranti',
            name: 'village_ristoranti',
            component: () => import("./views/ristoranti.vue"),
            meta: {
                hideTopCut: true
            }
        },
        {
            path: '/village/ristoranti/:poiName',
            name: 'village_ristoranti_detail',
            component: () => import("./views/poiDetails.vue"),
            meta: {
                hideTopCut: true
            }
        },
        {
            path: '/village/info',
            name: 'village_info',
            component: () => import("./views/info.vue"),
            meta: {
                hideTopCut: true,
                showMembership: true,
            }
        },
        {
            path: '/village/home/details',
            name: 'village_home_details',
            component: () => import("./views/villageDetails.vue"),
            meta: {
                hideBottomCut: true,
                hideTopCut: true
            }
        },
        {
            path: '/village/poiList/:poiType',
            name: 'village_poiList',
            component: () => import("./views/poiList.vue"),
        },
        {
            path: '/village/poiDetails/:poiName',
            name: 'village_poiDetails',
            component: () => import("./views/poiDetails.vue"),
        },
    ];
};